import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import { BiArrowBack } from "react-icons/bi";

import Contexts from "../contexts";

type Props = {
  children: any;
};

export const CookieManagementName = `${
  import.meta.env.VITE_STORAGE_PREFIX
}_IsCookiePermission`;

export function setCookie(name: string, value: string, days: number) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function getCookie(name: string) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function CookieManagementProvider({ children }: Props) {
  const { t } = useTranslation();
  const [isCookiePermission, setIsCookiePermission] = useState<boolean>(true);
  const [show, setShow] = useState<boolean>(false);
  const [step, setStep] = useState(1);

  useEffect(() => {
    const data = getCookie(CookieManagementName);
    if (data) {
      setShow(false);
      setIsCookiePermission(true);
    } else {
      setShow(true);
      setIsCookiePermission(false);
    }
  }, []);

  const onAccept = () => {
    setCookie(CookieManagementName, Date.now().toString(), 7);
    setShow(false);
    setIsCookiePermission(true);
    window.location.reload();
  };

  function eraseCookie(name: string) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  return (
    <>
      <Contexts.CookieManagementContext.Provider value={isCookiePermission}>
        {children}
      </Contexts.CookieManagementContext.Provider>
      {show && (
        <>
          {step == 1 && (
            <div className="tw-shadow-2xl tw-bottom-[10%] tw-left-[50%] tw-translate-x-[-50%]  tw-fixed md:tw-p-0 tw-p-3 tw-z-[9999] tw-rounded-xl  tw-bg-white tw-w-[90%] lg:tw-max-w-[970px]">
              <div className="md:tw-hidden tw-flex tw-justify-end tw-p-3">
                <span>
                  <AiOutlineClose
                    className="tw-cursor-pointer"
                    onClick={() => {
                      setShow(false);
                    }}
                  />
                </span>
              </div>
              <div className="md:tw-hidden tw-flex tw-justify-center">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="24" cy="24" r="24" fill="#E6EDFD" />
                  <path
                    d="M33.598 23.0636C33.4776 22.9728 33.3384 22.9102 33.1906 22.8804C33.0428 22.8506 32.8901 22.8545 32.744 22.8916C32.5016 22.9593 32.2516 22.9956 32 22.9996C30.346 22.9996 29 21.6536 28.997 20.0616C29.002 20.0276 29.013 19.9276 29.014 19.8936C29.0205 19.7373 28.9902 19.5816 28.9255 19.4392C28.8607 19.2967 28.7634 19.1715 28.6414 19.0735C28.5193 18.9756 28.376 18.9078 28.2229 18.8755C28.0698 18.8432 27.9112 18.8474 27.76 18.8876C27.5125 18.9574 27.2571 18.995 27 18.9996C25.346 18.9996 24 17.6536 24 15.9996C24 15.7826 24.031 15.5556 24.099 15.2836C24.1375 15.1284 24.1382 14.9661 24.101 14.8106C24.0638 14.655 23.9899 14.5106 23.8854 14.3895C23.7808 14.2684 23.6488 14.1742 23.5003 14.1147C23.3518 14.0552 23.1912 14.0322 23.032 14.0476C20.5555 14.2784 18.255 15.4279 16.5835 17.2697C14.9119 19.1116 13.9903 21.5124 14 23.9996C14 29.5136 18.486 33.9996 24 33.9996C29.514 33.9996 34 29.5136 34 23.9996C34 23.9506 33.997 23.9026 33.993 23.8396C33.9896 23.6889 33.9524 23.5409 33.884 23.4066C33.8156 23.2722 33.7179 23.155 33.598 23.0636ZM20.5 17.9996C20.8978 17.9996 21.2794 18.1577 21.5607 18.439C21.842 18.7203 22 19.1018 22 19.4996C22 19.8974 21.842 20.279 21.5607 20.5603C21.2794 20.8416 20.8978 20.9996 20.5 20.9996C20.1022 20.9996 19.7206 20.8416 19.4393 20.5603C19.158 20.279 19 19.8974 19 19.4996C19 19.1018 19.158 18.7203 19.4393 18.439C19.7206 18.1577 20.1022 17.9996 20.5 17.9996ZM18.5 25.9996C18.303 25.9996 18.108 25.9608 17.926 25.8854C17.744 25.8101 17.5786 25.6996 17.4393 25.5603C17.3001 25.421 17.1896 25.2556 17.1142 25.0737C17.0388 24.8917 17 24.6966 17 24.4996C17 24.3026 17.0388 24.1076 17.1142 23.9256C17.1896 23.7436 17.3001 23.5783 17.4393 23.439C17.5786 23.2997 17.744 23.1892 17.926 23.1138C18.108 23.0384 18.303 22.9996 18.5 22.9996C18.8978 22.9996 19.2794 23.1577 19.5607 23.439C19.842 23.7203 20 24.1018 20 24.4996C20 24.8974 19.842 25.279 19.5607 25.5603C19.2794 25.8416 18.8978 25.9996 18.5 25.9996ZM21.5 29.9996C21.1022 29.9996 20.7206 29.8416 20.4393 29.5603C20.158 29.279 20 28.8974 20 28.4996C20 28.1018 20.158 27.7203 20.4393 27.439C20.7206 27.1577 21.1022 26.9996 21.5 26.9996C21.8978 26.9996 22.2794 27.1577 22.5607 27.439C22.842 27.7203 23 28.1018 23 28.4996C23 28.8974 22.842 29.279 22.5607 29.5603C22.2794 29.8416 21.8978 29.9996 21.5 29.9996ZM24 23.4996C24 23.1018 24.158 22.7203 24.4393 22.439C24.7206 22.1577 25.1022 21.9996 25.5 21.9996C25.8978 21.9996 26.2794 22.1577 26.5607 22.439C26.842 22.7203 27 23.1018 27 23.4996C27 23.8974 26.842 24.279 26.5607 24.5603C26.2794 24.8416 25.8978 24.9996 25.5 24.9996C25.1022 24.9996 24.7206 24.8416 24.4393 24.5603C24.158 24.279 24 23.8974 24 23.4996ZM27.5 29.9996C27.1022 29.9996 26.7206 29.8416 26.4393 29.5603C26.158 29.279 26 28.8974 26 28.4996C26 28.1018 26.158 27.7203 26.4393 27.439C26.7206 27.1577 27.1022 26.9996 27.5 26.9996C27.8978 26.9996 28.2794 27.1577 28.5607 27.439C28.842 27.7203 29 28.1018 29 28.4996C29 28.8974 28.842 29.279 28.5607 29.5603C28.2794 29.8416 27.8978 29.9996 27.5 29.9996Z"
                    fill="#4167DA"
                  />
                </svg>
              </div>
              <div className="tw-flex tw-flex-col tw-py-4 tw-px-5">
                <div className="tw-flex tw-gap-3 tw-justify-center md:tw-justify-between">
                  <h2 className="m-0 font-sofiaSans p-0 tw-font-extrabold">
                    {t("CookieManagement/title")}
                  </h2>
                  <span className="lg:tw-block tw-hidden">
                    <AiOutlineClose
                      className="tw-cursor-pointer"
                      onClick={() => {
                        setShow(false);
                      }}
                    />
                  </span>
                </div>

                <div className="tw-flex tw-gap-3 font-sofiaSans tw-mt-6 tw-flex-col md:tw-flex-row">
                  <div className="tw-flex tw-items-center  tw-gap-2">
                    <span className="md:tw-block tw-hidden">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="24" cy="24" r="24" fill="#E6EDFD" />
                        <path
                          d="M33.598 23.0636C33.4776 22.9728 33.3384 22.9102 33.1906 22.8804C33.0428 22.8506 32.8901 22.8545 32.744 22.8916C32.5016 22.9593 32.2516 22.9956 32 22.9996C30.346 22.9996 29 21.6536 28.997 20.0616C29.002 20.0276 29.013 19.9276 29.014 19.8936C29.0205 19.7373 28.9902 19.5816 28.9255 19.4392C28.8607 19.2967 28.7634 19.1715 28.6414 19.0735C28.5193 18.9756 28.376 18.9078 28.2229 18.8755C28.0698 18.8432 27.9112 18.8474 27.76 18.8876C27.5125 18.9574 27.2571 18.995 27 18.9996C25.346 18.9996 24 17.6536 24 15.9996C24 15.7826 24.031 15.5556 24.099 15.2836C24.1375 15.1284 24.1382 14.9661 24.101 14.8106C24.0638 14.655 23.9899 14.5106 23.8854 14.3895C23.7808 14.2684 23.6488 14.1742 23.5003 14.1147C23.3518 14.0552 23.1912 14.0322 23.032 14.0476C20.5555 14.2784 18.255 15.4279 16.5835 17.2697C14.9119 19.1116 13.9903 21.5124 14 23.9996C14 29.5136 18.486 33.9996 24 33.9996C29.514 33.9996 34 29.5136 34 23.9996C34 23.9506 33.997 23.9026 33.993 23.8396C33.9896 23.6889 33.9524 23.5409 33.884 23.4066C33.8156 23.2722 33.7179 23.155 33.598 23.0636ZM20.5 17.9996C20.8978 17.9996 21.2794 18.1577 21.5607 18.439C21.842 18.7203 22 19.1018 22 19.4996C22 19.8974 21.842 20.279 21.5607 20.5603C21.2794 20.8416 20.8978 20.9996 20.5 20.9996C20.1022 20.9996 19.7206 20.8416 19.4393 20.5603C19.158 20.279 19 19.8974 19 19.4996C19 19.1018 19.158 18.7203 19.4393 18.439C19.7206 18.1577 20.1022 17.9996 20.5 17.9996ZM18.5 25.9996C18.303 25.9996 18.108 25.9608 17.926 25.8854C17.744 25.8101 17.5786 25.6996 17.4393 25.5603C17.3001 25.421 17.1896 25.2556 17.1142 25.0737C17.0388 24.8917 17 24.6966 17 24.4996C17 24.3026 17.0388 24.1076 17.1142 23.9256C17.1896 23.7436 17.3001 23.5783 17.4393 23.439C17.5786 23.2997 17.744 23.1892 17.926 23.1138C18.108 23.0384 18.303 22.9996 18.5 22.9996C18.8978 22.9996 19.2794 23.1577 19.5607 23.439C19.842 23.7203 20 24.1018 20 24.4996C20 24.8974 19.842 25.279 19.5607 25.5603C19.2794 25.8416 18.8978 25.9996 18.5 25.9996ZM21.5 29.9996C21.1022 29.9996 20.7206 29.8416 20.4393 29.5603C20.158 29.279 20 28.8974 20 28.4996C20 28.1018 20.158 27.7203 20.4393 27.439C20.7206 27.1577 21.1022 26.9996 21.5 26.9996C21.8978 26.9996 22.2794 27.1577 22.5607 27.439C22.842 27.7203 23 28.1018 23 28.4996C23 28.8974 22.842 29.279 22.5607 29.5603C22.2794 29.8416 21.8978 29.9996 21.5 29.9996ZM24 23.4996C24 23.1018 24.158 22.7203 24.4393 22.439C24.7206 22.1577 25.1022 21.9996 25.5 21.9996C25.8978 21.9996 26.2794 22.1577 26.5607 22.439C26.842 22.7203 27 23.1018 27 23.4996C27 23.8974 26.842 24.279 26.5607 24.5603C26.2794 24.8416 25.8978 24.9996 25.5 24.9996C25.1022 24.9996 24.7206 24.8416 24.4393 24.5603C24.158 24.279 24 23.8974 24 23.4996ZM27.5 29.9996C27.1022 29.9996 26.7206 29.8416 26.4393 29.5603C26.158 29.279 26 28.8974 26 28.4996C26 28.1018 26.158 27.7203 26.4393 27.439C26.7206 27.1577 27.1022 26.9996 27.5 26.9996C27.8978 26.9996 28.2794 27.1577 28.5607 27.439C28.842 27.7203 29 28.1018 29 28.4996C29 28.8974 28.842 29.279 28.5607 29.5603C28.2794 29.8416 27.8978 29.9996 27.5 29.9996Z"
                          fill="#4167DA"
                        />
                      </svg>
                    </span>
                    <p className="m-0 p-0 md:tw-text-left tw-text-center">
                      {t("CookieManagement/des-01")}
                    </p>
                  </div>
                  <div className="tw-flex tw-gap-2 md:tw-flex-row tw-flex-col-reverse">
                    <Button
                      variant="outline-primary"
                      className="tw-bg-white tw-flex tw-justify-center  tw-border-solid tw-border-blue-800 tw-border-[2px] hover:tw-bg-white"
                      onClick={() => {
                        setStep(2);
                      }}
                    >
                      {t("CookieManagement/btn-02")}
                    </Button>
                    <Button
                      variant="primary"
                      onClick={onAccept}
                      className="tw-flex tw-justify-center"
                    >
                      {t("CookieManagement/btn-01")}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="tw-flex tw-bg-gray-200">
                <p className="m-0 tw-py-4 tw-px-5 font-sofiaSans tw-text-xs">
                  {t("CookieManagement/des-02")}
                </p>
              </div>
            </div>
          )}
          {step == 2 && (
            <div className="tw-shadow-2xl tw-bottom-[10%] tw-left-[50%] tw-translate-x-[-50%]  tw-fixed md:tw-p-0 tw-p-3 tw-z-[9999] tw-rounded-xl  tw-bg-white tw-w-[90%] lg:tw-max-w-[970px]">
              <div className="tw-flex tw-flex-col tw-py-4 tw-px-5">
                <div className="tw-flex tw-gap-1 tw-items-center">
                  <span className="tw-mb-1">
                    <BiArrowBack
                      className="tw-text-2xl tw-text-gray-400"
                      onClick={() => {
                        setStep(1);
                      }}
                    />
                  </span>
                  <h3 className="m-0 font-sofiaSans p-0">
                    {t("CookieManagement/title-01")}
                  </h3>
                </div>
                <div>
                  <p className="m-0 p-0 font-sofiaSans">
                    {t("CookieManagement/des-03")}
                  </p>
                </div>

                <div className="tw-flex tw-gap-3 tw-justify-between font-sofiaSans tw-mt-6 md:tw-flex-row tw-flex-col">
                  <div className="tw-flex tw-items-start md:tw-items-center md:tw-gap-2 font-sofiaSans tw-font-bold tw-flex-col md:tw-flex-row">
                    <ul className="m-0">
                      <li>
                        <a
                          className="tw-underline"
                          target="_blank"
                          href=" https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                        >
                          Microsoft Internet Explorer (IE)
                        </a>
                      </li>
                      <li>
                        <a
                          className="tw-underline"
                          target="_blank"
                          href=" https://support.google.com/accounts/answer/32050"
                        >
                          Google Chrome
                        </a>
                      </li>
                    </ul>
                    <ul className="m-0">
                      <li>
                        <a
                          className="tw-underline"
                          target="_blank"
                          href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac"
                          rel="noreferrer"
                        >
                          Safari
                        </a>
                      </li>
                      <li>
                        <a
                          className="tw-underline"
                          target="_blank"
                          href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox"
                          rel="noreferrer"
                        >
                          Firefox
                        </a>
                      </li>
                    </ul>
                    <ul className="m-0">
                      <li>
                        <a
                          className="tw-underline"
                          target="_blank"
                          href="https://www.google.com/search?q=how+to+disable+cookies+in+my+browser"
                          rel="noreferrer"
                        >
                          Other browsers
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tw-flex tw-gap-2 md:tw-flex-row tw-flex-col-reverse">
                    <Button
                      variant="outline-primary"
                      className="tw-bg-white tw-flex tw-justify-center  tw-border-solid tw-border-blue-800 tw-border-[2px] hover:tw-bg-white"
                      onClick={() => {
                        setStep(1);
                      }}
                    >
                      {t("CookieManagement/btn-04")}
                    </Button>
                    <Button
                      className="tw-flex tw-justify-center"
                      variant="primary"
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      {t("CookieManagement/btn-03")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default CookieManagementProvider;
